import { Sparkles, Loader2 } from "lucide-react";

const CinemaAIIcon = ({ isProcessing }: { isProcessing?: boolean }) => {
  return (
    <div className="relative flex items-center justify-center w-[18px] h-[18px]">
      <svg
        viewBox="0 0 24 24"
        className={`w-full h-full stroke-[#1e769c] ${isProcessing ? "animate-[spin_2s_linear_infinite]" : ""}`}
        fill="none"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        {isProcessing ? (
          <path d="M21 12a9 9 0 1 1-6.219-8.56" />
        ) : (
          <>
            <rect x="2" y="2" width="20" height="20" rx="2.5" />
            <path d="M7 2v20" />
            <path d="M17 2v20" />
            <path d="M2 12h20" />
            <path d="M2 7h5" />
            <path d="M2 17h5" />
            <path d="M17 17h5" />
            <path d="M17 7h5" />
          </>
        )}
      </svg>
    </div>
  );
};

const SummarizeButton = ({
  onSummarize,
  isSummarizing,
  sparkleOnly = false,
}: {
  onSummarize?: () => void;
  isSummarizing?: boolean;
  sparkleOnly?: boolean;
}) => {
  if (sparkleOnly) {
    return (
      <button
        onClick={onSummarize}
        disabled={isSummarizing}
        title={isSummarizing ? "Analyzing Scene..." : "Summarize Scene"}
        className={`relative inline-flex items-center justify-center w-10 h-10 rounded-full border outline-none transition-all duration-300 ease-out shrink-0 ${
          isSummarizing
            ? "border-blumine-300 bg-blumine-100 cursor-wait shadow-[0_0_0_4px_#eefafd]"
            : "border-blumine-200 bg-blumine-50 cursor-pointer hover:border-blumine-300 hover:bg-blumine-100 hover:shadow-[0_8px_24px_-6px_rgba(32,146,186,0.35)] hover:scale-105 active:scale-95"
        }`}
      >
        <span
          className={`absolute inset-0 rounded-[inherit] ${
            isSummarizing
              ? "bg-[linear-gradient(135deg,#d5f1f8_0%,#b0e3f1_100%)]"
              : "bg-[linear-gradient(135deg,#eefafd_0%,#d5f1f8_100%)]"
          }`}
        />
        <span className="relative z-10 flex items-center justify-center text-blumine-500">
          {isSummarizing ? (
            <Loader2 className="w-5 h-5 animate-spin text-blumine-400" />
          ) : (
            <Sparkles className="w-5 h-5 text-blumine-400" />
          )}
        </span>
      </button>
    );
  }

  return (
    <button
      onClick={onSummarize}
      disabled={isSummarizing}
      className={`relative inline-flex items-center justify-center overflow-hidden px-7 py-3.5 rounded-[2.5rem] border outline-none transition-all duration-300 ease-out ${
        isSummarizing
          ? "border-[#7acee6] bg-[#d5f1f8] cursor-wait shadow-[0_0_0_4px_#eefafd]"
          : "border-[#b0e3f1] bg-[#eefafd] cursor-pointer hover:border-[#7acee6] hover:bg-[#d5f1f8] hover:shadow-[0_8px_24px_-6px_rgba(32,146,186,0.18)] hover:-translate-y-[1px]"
      }`}
    >
      <span
        className={`absolute inset-0 rounded-[inherit] ${
          isSummarizing
            ? "bg-[linear-gradient(135deg,#d5f1f8_0%,#b0e3f1_100%)]"
            : "bg-[linear-gradient(135deg,#eefafd_0%,#d5f1f8_100%)]"
        }`}
      />

      <span className="relative z-10 flex items-center gap-3">
        <CinemaAIIcon isProcessing={isSummarizing} />

        <span className="flex flex-col items-start leading-none">
          <span className="text-[13px] font-semibold text-[#1d5b79] tracking-[0.01em]">
            {isSummarizing ? "Analyzing Scene..." : "Summarize Scene"}
          </span>
          <span
            className={`text-[9px] font-medium uppercase tracking-[0.12em] mt-1 ${
              isSummarizing ? "text-[#2092ba]" : "text-[#3cafd4]"
            }`}
          >
            {isSummarizing ? "AI Engine Active" : ""}
          </span>
        </span>
      </span>
    </button>
  );
};

export default SummarizeButton;
